import { createFileRoute, stripSearchParams } from "@tanstack/react-router";
import { SensorStatusSearchParams } from "./sensor-status";

export type SensorViewParams = SensorStatusSearchParams & {
  mainTab?: string;
};

const defaultValues: SensorViewParams = {
  search: "",
  postalCode: "",
  status: "",
  batteryLevel: "",
  cableStatus: "",
  retired: false,
  mainTab: "overview",
};
export const Route = createFileRoute("/sensor-status/$id")({
  validateSearch: (params: Record<string, unknown>): SensorViewParams => {
    // validate and parse the search params into a typed state
    return {
      search: (params["search"] as string) ?? "",
      postalCode: params["postalCode"]?.toString() ?? "",
      status: (params["status"] as string) ?? "",
      batteryLevel: (params["batteryLevel"] as string) ?? "",
      cableStatus: (params["cableStatus"] as string) ?? "",
      retired: (params["retired"] as boolean) ?? false,
      mainTab: (params["mainTab"] as string) ?? "overview",
    };
  },
  search: {
    middlewares: [stripSearchParams(defaultValues)],
  },
});
